import { useMemo } from "react";
import { User } from "@common/types/user";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";

const pickUsers = (userIds: number[], members: Array<{ user: User }>): User[] =>
    userIds.flatMap((userId) => {
        const member = members.find(({ user }) => user.id === userId);
        return member ? [member.user] : [];
    });

export const usePresenceUsers = (userIds: number[]) => {
    const { data: members = [] } = useCurrentWorkspaceMembers();

    return useMemo(() => pickUsers(userIds, members), [userIds, members]);
};

export const useOrganizationPresenceUsers = (userIds: number[]) => {
    const { data: members = [] } = useCurrentOrganizationMembers();

    return useMemo(() => pickUsers(userIds, members), [userIds, members]);
};
